export var CrudTemplate = /*#__PURE__*/function (CrudTemplate) {
  CrudTemplate["ListItem"] = "ListItem";
  CrudTemplate["EditorInnerForm"] = "EditorInnerForm";
  return CrudTemplate;
}(CrudTemplate || {});